import axios from "axios";

// In production behind Nginx reverse proxy or local CRA proxy, relative '/api' is used.
// If an external API URL is explicitly configured, use that instead.
const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL.replace(/\/$/, "")}/api`
  : "/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let authFailureHandler = null;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ahc_auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const renewedToken = response.headers?.get?.("x-auth-token") ||
      response.headers?.["x-auth-token"];
    if (renewedToken) {
      localStorage.setItem("ahc_auth_token", renewedToken);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && authFailureHandler) {
      authFailureHandler(error);
    }
    return Promise.reject(error);
  },
);

export const assessmentAPI = {
  getAll: () => api.get("/assessments"),
  getById: (id) => api.get(`/assessments/${id}`),
  create: (data) => api.post("/assessments", data),
  update: (id, data) => api.put(`/assessments/${id}`, data),
  delete: (id) => api.delete(`/assessments/${id}`),
  uploadEvidence: (formData) =>
    api.post("/uploads/evidence", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  exportUrl: (id) => `${api.defaults.baseURL}/assessments/${id}/export`,
};

export const adminAPI = {
  listUsers: () => api.get("/users"),
  createUser: (data) => api.post("/users", data),
  updateUserRole: (id, role) => api.patch(`/users/${id}/role`, { role }),
  deleteUser: (id) => api.delete(`/users/${id}`),
};

export const authAPI = {
  login: (data) => api.post("/auth/login", data),
  me: () => api.get("/auth/me"),
  updateProfile: (data) => api.put("/auth/profile", data),
  changePassword: (data) => api.put("/auth/change-password", data),
  logout: () => api.post("/auth/logout"),
};

export const setAuthFailureHandler = (handler) => {
  authFailureHandler = handler;
};

export default api;
